/*
 * Copyright (c) 2025 Ipivot Corporation.
 * All rights reserved.
 * This software is the confidential and proprietary information of
 *  Ipivot Corporation ("Confidential Information").
 */
import { useState, useEffect, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Tabs, Tab } from 'react-bootstrap';
import { Row, Col } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import { FingerTools } from './FingerTools';
import { createGlobalStyle } from 'styled-components';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import { StatusContext, StatusContextType } from './StatusContext';
import { statDash, FingerprintStat } from '../data';
import LayerStats from './LayerStats';
import CatStats from './CatStats';
import ProbeStats from './ProbeStats';
import UsageStats from './UsageStats';

function DashOverview({ }) {
    const statusContext = useContext(StatusContext);
    const [fpStats, setFpStats] = useState<FingerprintStat | null>(null);
    const [refresh, setRefresh] = useState(true);

    useEffect(() => {
        async function fetchStats() {
            if (!refresh) {
                return;
            }
            try {
                const s = await statDash();
                setFpStats(s);
            } catch (error : any) {
                statusContext.postError(`Error fetching stats: ${error.message}`);
                console.error('Error fetching stats:', error);
            } finally {
                setRefresh(false);
            }
        }
        fetchStats();
    }, [ refresh ]);

    return (
        <Container fluid className="pt-3 px-4">
            <Row className="align-items-center mb-3">
                <Col>
                    <div className="p-4 border border-primary"
                        style={{ overflowY: "auto", height: "400px" }}>
                        <h3>Probe</h3>
                        <ProbeStats data={fpStats} />
                    </div>
                </Col>
                <Col>
                    <div className="p-4 border border-primary"
                        style={{ overflowY: "auto", height: "400px" }}>
                        <h3>Category</h3>
                        <CatStats data={fpStats} />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="p-4 border border-primary"
                        style={{ overflowY: "auto", height: "400px" }}>
                        <h3>Layers</h3>
                        <LayerStats data={fpStats} />
                    </div>
                </Col>
                <Col>
                    <div className="p-4 border border-primary"
                        style={{ overflowY: "auto", height: "400px" }}>
                        <h3>Usage Statistics</h3>
                        <UsageStats />
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

const GlobalStyle = createGlobalStyle`
    :root {
        --bs-nav-tabs-border-width: 10px;
    }
    `;

export default DashOverview;